import React, { FC } from 'react'
import { IUploadedImageAsset } from '@api'
import { Spinner } from '@ui'
import { ImageItem } from './components'
import css from './imageList.module.scss'

type ImagesListPropsT = {
  assets: IUploadedImageAsset[]
  isAssetsLoading: boolean
  onDeleteImage: (id: string) => void
  onClickDefaultImage: (id: string) => void
}

const ImagesList: FC<React.PropsWithChildren<ImagesListPropsT>> = ({
  assets,
  isAssetsLoading,
  onDeleteImage,
  onClickDefaultImage,
}) => {
  if (isAssetsLoading) {
    return <Spinner size={32} />
  }

  return (
    <div data-test="upload-images-list" className={css.list}>
      {assets.map((asset) => (
        <ImageItem
          key={asset.id}
          onDeleteImage={() => onDeleteImage(asset.id)}
          onClickDefaultImage={() => onClickDefaultImage(asset.id)}
          isDefault={asset.isDefault}
          asset={asset}
        />
      ))}
    </div>
  )
}

export default ImagesList
